export interface AppointmentFormValues {
  hospitalId: number | null;
  personId: number | null;
  tagNumberId?: number | null;
  userId: string | null;
  appointmentDate: string;
  appointmentStartTime: string;
  appointmentEndTime: string;
  deviceList: string;
  notes?: string;
  status?: string;
  requestNumber?: string;
}

export interface IAppointment {
  id?: number;
  hospitalId?: number;
  tagNumberId?: number | null;
  tagPrefix?: string;
  hospitalName?: string;
  hospitalLocation?: string;
  personId?: number;
  personName?: string;
  userId?: string | null;
  userName?: string;
  appointmentDate?: string;
  appointmentStartTime?: string;
  appointmentEndTime?: string;
  deviceList?: string;
  notes?: string;
  status?: string;
  requestNumber?: string;
}

export const appointmentInitialValues: AppointmentFormValues = {
  hospitalId: null,
  personId: null,
  userId: null,
  appointmentDate: new Date().toISOString().split('T')[0],
  appointmentStartTime: '',
  appointmentEndTime: '',
  deviceList: '',
  notes: '',
  status: '',
  requestNumber: '',
};
